
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { comForm } from "@newview/ui";
import { request } from "@newview/infrastructure";
@Component({
  name: "",
  components: {
    comForm,
  },
})
export default class BusinessClass extends BaseVue {
  @Prop({ default: null }) Type!: any;
  @Prop({ default: "" }) Name!: any;
  @Prop({ default: 0 }) pagecode!: any;
  @Prop({ default: "100%" }) width!: any;
  @Prop({ default: "100%" }) height!: any;
  @Prop({ default: () => ('') }) dataApi!: any;

  //#region 接口定义区

  //#endregion 接口定义区

  //#region 变量定义区
  QRSrc: any = "";
  style = {
    width: this.width,
    height: this.height,
  };
  //#endregion 变量定义区

  //#region 事件定义区
  async mounted() {
    let obj: any = null
    let projectd = this.G_ProjectDataId
    let data: any = null
    if(projectd == 23) { // 秦唐  根据项目id区分
      obj = { sceneStr: this.Type.pageCode+"_"+this.Type.Id, page: "pages/BasePage/MiddlePage",envVersion:"release"};
      data = await this.dataApi.getQTMiniProgramQrCode(
        obj
        )
      } else if(projectd == 27) { // 石太
        obj = { sceneStr: this.Type.pageCode+"_"+this.Type.Id, page: "pages/BasePage/MiddlePage",envVersion:"release"};
      data = await this.dataApi.GetMiniProgramQrCode(
        obj
      );
    }
    console.log('222222',this.Type);
    console.log('111111',this.Name);
    console.log('ssss',obj);
    console.log('xxxx',data);
    
    if (data.code == 200) {
      this.QRSrc = "data:image/jpg;base64," + data.data;
      let file:any = this.base64ToFile(this.QRSrc,"压路机")
      this.$emit("success");
    }
  }
base64ToFile(base64, fileName) {
  let arr = base64.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bytes = atob(arr[1]);
  let n = bytes.length
  let ia = new Uint8Array(n);
  while (n--) {
      ia[n] = bytes.charCodeAt(n);
  }
  return new File([ia], fileName, { type: mime });
}
  //#endregion 事件定义区

  //#region 方法定义区

  //#endregion 方法定义区
}
